import { useQuery } from '@tanstack/react-query';
import { providerTeamsService } from '@/services/provider/provider-teams.service';

export const providerTeamKeys = {
  all: ['provider', 'teams'] as const,
};

export function useProviderTeams() {
  return useQuery({
    queryKey: providerTeamKeys.all,
    queryFn: () => providerTeamsService.list(),
    staleTime: 5 * 60 * 1000,
  });
}
